export default __webpack_public_path__ + "static/media/_litecoin-cash.ea01f724.svg";